module.exports = __webpack_public_path__ + "static/snowball-footer-vid-1ce0e60426ab1d43adafb8962d10e839.mp4";